import React, { Component } from "react";

import { ProgressBar } from "react-bootstrap";

class CommonLoadingBar extends Component{

    constructor(props) {
        super(props);
        this.state = {
            progress: 0,
            isLoading: false
        };
        this.interval = null;
    }
    
    startLoading = () => {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    
        this.setState({ isLoading: true, progress: 0 });
    
        this.interval = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.progress >= 100) {
                    clearInterval(this.interval);
                    this.interval = null;
    
                    setTimeout(() => {
                        if (this.props.isLoading) {
                            this.setState({ progress: 0 }, () => {
                                setTimeout(() => {
                                    this.startLoading();
                                }, 500);
                            });
                        }
                    }, 500);
    
                    return { progress: 100 };
                }
    
                return { progress: prevState.progress + 10 };
            });
        }, 50);
    };
    
    componentDidUpdate = (prevProps) => {
        // console.log("======================loading mounting=============", prevProps.isLoading, this.props.isLoading);
        if (prevProps.isLoading !== this.props.isLoading) {
            if (this.props.isLoading) {
                this.startLoading();
            } else {
                this.setState({ progress: 100 }, () => {
                    setTimeout(() => {
                        clearInterval(this.interval);
                        this.interval = null;
                        this.setState({ isLoading: false, progress: 0 });
                    }, 500); 
                });
            }
        }
    };

    componentWillUnmount = () => {
        clearInterval(this.interval);
        this.interval = null;
    };
    
    render = () => {
        let { variant = 'primary' } = this.props;

        return (
            <div>
                {this.state.isLoading && (
                    <ProgressBar 
                        now={this.state.progress}
                        variant={variant}
                        style={{
                            position: "d",
                            top: "-5px",
                            left: 0,
                            width: "100%",
                            height: '3px',
                            zIndex: 9999
                        }}
                        animated
                    />
                )}
            </div>
        )
    }
}

export default CommonLoadingBar;